import React from "react";
import PropTypes from "prop-types";
import BookmarkRecommendation from "../BookmarkRecommendation";

const RecommendationsList = ({ items, listTitle = "" }) => {
  if (!items || !items.length) {
    return <div className="myad-recommendations-widget" />;
  }

  return (
    <div
      className="myad-recommendations-widget"
      data-insights-category="myad-feed"
      data-insights-label="bookmarks-recommendations"
      data-insights-value={listTitle}
    >
      <h2 className="afd-title-big afd-title-big--bmargin-big">
        <div dangerouslySetInnerHTML={{ __html: listTitle }} />
      </h2>
      <ul
        className="myad-desktop-margin myad-bookmark-grid myad-bookmark-grid--recommendations"
      >
        {items.map(item => (<div key={item.id}><BookmarkRecommendation item={item} /></div>))}
      </ul>
    </div>
  );
};

RecommendationsList.propTypes = {
  listTitle: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }))
};

RecommendationsList.defaultProps = {
  items: null
};

export default RecommendationsList;
